import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useSilver } from "@/context/SilverContext";
import { DISTRICT_COUNT } from "@/lib/audienceEngine";

const POINTS = [
  "Results are audience counts and estimates taken from the supplied postcode-district dataset.",
  "Totals add up the unique audience profiles that match your criteria, so overlapping signals are never double-counted.",
  "A result is not an indication that any individual household is currently selling or planning to move.",
  "Campaign availability, specification and final pricing are subject to confirmation by NicheCom Print.",
];

export function HowCalculatedDialog() {
  const { howOpen, setHowOpen } = useSilver();
  return (
    <Dialog open={howOpen} onOpenChange={setHowOpen}>
      <DialogContent className="max-w-xl !rounded-[28px] border border-white/10 !bg-[rgba(12,30,16,0.96)] p-8 text-white backdrop-blur-2xl" data-testid="how-calculated-dialog">
        <DialogHeader className="text-left">
          <p className="eyebrow">Data & method</p>
          <DialogTitle className="mt-2 text-3xl font-extrabold tracking-[-0.04em] text-white">How is this calculated?</DialogTitle>
          <DialogDescription className="pt-3 text-[15px] leading-relaxed text-white/70">
            This tool combines postcode-level audience counts with selected Mosaic audience characteristics to help estate agents understand the potential size and composition of relevant homeowner audiences in their local market.
          </DialogDescription>
        </DialogHeader>
        <ul className="mt-4 space-y-3">
          {POINTS.map((p) => (
            <li key={p} className="flex gap-3 text-[14px] leading-relaxed text-white/70"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#96C11F]" />{p}</li>
          ))}
        </ul>
        <div className="mt-4 rounded-2xl border border-white/10 bg-black/20 p-4 text-[13px] leading-relaxed text-white/55">
          <strong className="text-white">Filter logic.</strong> Choices within the same group (for example 3 bed or 4 bed) widen the audience. Different groups (stage, property, opportunity) narrow it. Opportunity signals match any selected signal unless you choose “Match all”. Local density compares your average per district with the average of all {DISTRICT_COUNT.toLocaleString("en-GB")} districts in the dataset.
        </div>
      </DialogContent>
    </Dialog>
  );
}
